import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TransportistaGatewayHttpService,
  TransportistaGatewayPostOptions,
} from '../interceptor/http';

/** Cuerpo POST /satisfaccion (Swagger: SatisfaccionTransportistaRequest). */
export type SatisfaccionTransportistaBody = {
  puntos: string;
};

/** POST /api/transportista/satisfaccion */
@Injectable({ providedIn: 'root' })
export class TransportistaSatisfaccionGatewayApi {
  constructor(private readonly gw: TransportistaGatewayHttpService) {}

  post(
    body: SatisfaccionTransportistaBody,
    options?: TransportistaGatewayPostOptions
  ): Observable<unknown> {
    return this.gw.post<unknown>('/satisfaccion', body, options);
  }
}
